// removed by extract-text-webpack-plugin
module.exports = {"oe-select":"SelectBrand-module-oe-select-1vjyy","oeSelect":"SelectBrand-module-oe-select-1vjyy","select-container":"SelectBrand-module-select-container-2BwJc","selectContainer":"SelectBrand-module-select-container-2BwJc","arrow":"SelectBrand-module-arrow-3AL9a","icon":"SelectBrand-module-icon-2zg-0","select":"SelectBrand-module-select-2zxXv"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/Product/components/SelectBrand/SelectBrand.module.scss
// module id = 1226
// module chunks = 0